import _ from 'lodash'

const PREFIX_REGEX = /^vrn:([a-z0-9-]+)::/

export const addPrefix = (text, entity) => PREFIX_REGEX.test(text) ? text : `vrn:${entity}::${text}`
export const stripPrefix = text => _.replace(text, PREFIX_REGEX, '')
export const setPrefix = (text, entity) => addPrefix(stripPrefix(text), entity)
